(function () {
  const ROOT_SELECTOR = '[data-saved-product-root]';

  function updateButtonState(root, nextState) {
    const button = root.querySelector('[data-saved-product-button]');
    const label = root.querySelector('[data-saved-product-label]');
    if (!button || !label) return;

    button.dataset.state = nextState;

    if (nextState === 'saved') {
      button.classList.add('is-saved');
      label.textContent = 'Saved';
      return;
    }

    button.classList.remove('is-saved');
    label.textContent = 'Save';
  }

  function setMessage(root, text, tone) {
    const message = root.querySelector('[data-saved-product-message]');
    if (!message) return;

    if (!text) {
      message.hidden = true;
      message.textContent = '';
      message.dataset.tone = '';
      return;
    }

    message.hidden = false;
    message.textContent = text;
    message.dataset.tone = tone || 'info';
  }

  function readPayload(root) {
    const node = root.querySelector('[data-saved-product-payload]');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.error('Failed to parse saved product payload.', error);
      return null;
    }
  }

  function readSessionUserId() {
    const headerRoot = document.querySelector('[data-user-portal-session-root]');
    const headerUserId = headerRoot?.dataset.userPortalUserId || '';
    const storedUserId = window.sessionStorage.getItem('itmart24_user_portal_user_id') || '';
    return headerUserId || storedUserId || '';
  }

  function normalizeUrl(value) {
    const input = String(value || '').trim();
    if (!input) return '';

    try {
      return new URL(input).toString();
    } catch (_error) {
      return '';
    }
  }

  function normalizeText(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim();
  }

  function sanitizePayload(rawPayload) {
    if (!rawPayload || typeof rawPayload !== 'object') {
      return null;
    }

    return {
      ...rawPayload,
      productId: normalizeText(rawPayload.productId),
      shopifyProductId: normalizeText(rawPayload.shopifyProductId),
      productHandle: normalizeText(rawPayload.productHandle),
      productName: normalizeText(rawPayload.productName),
      vendorName: normalizeText(rawPayload.vendorName),
      category: normalizeText(rawPayload.category),
      productUrl: normalizeUrl(rawPayload.productUrl),
      productLogoUrl: normalizeUrl(rawPayload.productLogoUrl),
      officialUrl: normalizeUrl(rawPayload.officialUrl),
      userNote: normalizeText(rawPayload.userNote),
    };
  }

  function buildStatusUrl(root) {
    const apiBase = root.dataset.apiBase || '';
    if (!apiBase) return '';

    const url = new URL(`${apiBase.replace(/\/$/, '')}/saved-products/status`);
    if (root.dataset.productId) url.searchParams.set('productId', root.dataset.productId);
    if (root.dataset.shopifyProductId) url.searchParams.set('shopifyProductId', root.dataset.shopifyProductId);
    if (root.dataset.productHandle) url.searchParams.set('productHandle', root.dataset.productHandle);
    if (root.dataset.officialUrl) url.searchParams.set('officialUrl', root.dataset.officialUrl);
    return url.toString();
  }

  async function checkSavedState(root) {
    const statusUrl = buildStatusUrl(root);
    if (!statusUrl) return;

    try {
      const response = await fetch(statusUrl, {
        credentials: 'include',
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        return;
      }

      const payload = await response.json();
      if (payload?.data?.saved) {
        updateButtonState(root, 'saved');
      }
    } catch (error) {
      console.error('Failed to check saved product status.', error);
    }
  }

  async function saveProduct(root) {
    const apiBase = root.dataset.apiBase || '';
    const payload = sanitizePayload(readPayload(root));
    const button = root.querySelector('[data-saved-product-button]');

    if (!apiBase || !payload || !button) {
      setMessage(root, 'Save action is not configured yet.', 'error');
      return;
    }

    if (button.disabled) return;

    button.disabled = true;
    setMessage(root, '', '');

    const sessionUserId = readSessionUserId();
    if (sessionUserId) {
      payload.metadata = {
        ...(payload.metadata || {}),
        sessionUserId,
      };
    }

    try {
      const response = await fetch(`${apiBase.replace(/\/$/, '')}/saved-products`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.status === 401) {
        setMessage(root, 'Log in to save products', 'error');
        return;
      }

      if (!response.ok) {
        let details = null;
        try {
          details = await response.json();
        } catch (_error) {
          details = null;
        }

        console.error('Failed to save product response.', {
          status: response.status,
          details,
          payload,
        });
        throw new Error(`Save request failed with status ${response.status}`);
      }

      updateButtonState(root, 'saved');
      setMessage(root, 'Saved to your ITMart24 workspace.', 'success');
    } catch (error) {
      console.error('Failed to save product.', error);
      setMessage(root, 'Unable to save this product right now.', 'error');
    } finally {
      button.disabled = false;
    }
  }

  function mount(root) {
    if (root.dataset.savedProductMounted === 'true') return;
    root.dataset.savedProductMounted = 'true';

    const button = root.querySelector('[data-saved-product-button]');
    if (button) {
      button.addEventListener('click', function () {
        saveProduct(root);
      });
    }

    checkSavedState(root);
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
